import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { MdClose, MdCheck } from "react-icons/md";

import FieldError from "../../../shared/FieldError";

const Bmi = ({ data, handleField }) => {
  const bmi = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .matches(/^\d*\.{1,2}\d*$/, "BMI must be a floating value e.g. 23.10"),
  });

  return (
    <div>
      <Formik
        initialValues={{
          data: data.value,
        }}
        validationSchema={bmi}
        validateOnChange={true}
        onSubmit={async (values) =>
          await handleField({
            id: data.id,
            value: values.data,
            cpr_id: data.cprId,
            quality_measurement_type_id: data.quality_measurement_type_id,
          })
        }
      >
        {({ values, errors, setFieldValue, initialValues }) => {
          return (
            <Form>
              <label>
                Body Mass Index <span id="from">(BMI)</span>
              </label>
              <input
                className="default"
                placeholder="e.g. 23.10"
                value={values.data}
                onChange={(e) => setFieldValue("data", e.target.value)}
              />
              {initialValues.data !== values.data && !errors.data && (
                <div className="check-cancel-buttons flex">
                  <button className="check small" type="submit">
                    <MdCheck className="check-icon" />
                  </button>
                  <button
                    className="cancel small"
                    onClick={() => {
                      initialValues.data
                        ? setFieldValue("data", initialValues.data)
                        : setFieldValue("data", "");
                    }}
                  >
                    <MdClose className="cancel-icon" />
                  </button>
                </div>
              )}
              {errors.data ? <FieldError error={errors.data} /> : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Bmi;
